import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
export var SafeTransferFrom = createPlugin({
    protocol: 'ERC721',
    type: 'ACTION',
    method: 'safeTransferFrom',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721', isPreview: true }),
                methodParams: {
                    from: new FctAddress({}),
                    to: new FctAddress({ isPreview: true }),
                    tokenId: new FctValue({}),
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params, _chainId, _walletAddress, vaultAddress) {
        var to = params.to, tokenId = params.methodParams.tokenId;
        if (!vaultAddress)
            return [];
        var from = params.methodParams.from.value;
        if (!vaultAddress || (typeof from === 'string' && vaultAddress.toLowerCase() === from.toLowerCase()))
            return [];
        return [
            {
                to: to.value,
                from: from,
                params: { to: vaultAddress, tokenId: tokenId.value },
                method: 'approve',
                protocol: 'ERC721',
            },
        ];
    },
});
